module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$root.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.$root.isAdmin) ? _c('SettingsAdmin', {
    attrs: {
      "settingsData": _vm.settingsData
    }
  }) : _c('SettingsDealer', {
    attrs: {
      "settingsData": _vm.settingsData
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "footerSettings"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "align": "right",
      "name": "Save"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f4a304e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings.vue
// module id = 762
// module chunks = 0